import {
  axiosInstance as axios,
  domain,
  setData,
  getData,
  deleteUserData,
} from "../utils/util";
import SET_LOADER from "../actionTypes/loader_set";
import { hist } from "../index";
import toastr from "toastr";
import MANAGE_CUSTOMERS from "../actionTypes/manageCustomers";
toastr.options = {
  closeButton: true,
  preventDuplicates: true,
  progressBar: true,
};

export const getCustomerData = () => (dispatch) => {
  try {
    let response = {
      data: [
        {
          _id: "123",
          firstName: "Alok",
          middleName: "Kumar",
          lastName: "Sharma",
          familyName: "abc",
          role: "IT Infra",
          email: "alok@gmail.com",
          isActive: true,
        },
        {
          _id: "1234",
          firstName: "Alok",
          middleName: "Kumar",
          lastName: "Sharma",
          familyName: "abc",
          role: "IT Infra",
          email: "alok@gmail.com",
          isActive: true,
        },
        {
          _id: "1235",
          firstName: "Alok",
          middleName: "Kumar",
          lastName: "Sharma",
          familyName: "abc",
          role: "IT Infra",
          email: "alok@gmail.com",
          isActive: true,
        },
        {
          _id: "1236",
          firstName: "Alok",
          middleName: "Kumar",
          lastName: "Sharma",
          familyName: "abc",
          role: "IT Infra",
          email: "alok@gmail.com",
          isActive: true,
        },
        {
          _id: "1237",
          firstName: "Alok",
          middleName: "Kumar",
          lastName: "Sharma",
          familyName: "abc",
          role: "IT Infra",
          email: "alok@gmail.com",
          isActive: true,
        },
      ],
    };
    dispatch({ type: MANAGE_CUSTOMERS.GET_CUSTOMERS, payload: response.data });
  } catch (error) {}
};
